import { render, staticRenderFns } from "./BancoEdit.vue?vue&type=template&id=2f3b8621&"
import script from "./BancoEdit.vue?vue&type=script&lang=js&"
export * from "./BancoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm,QInput,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QInput,QBtn})
